var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9359 32.3532L57.375 35.6204L48.875 19.3641L55.5156 16.0438C56.0091 15.7923 56.5821 15.746 57.1095 15.9152C57.637 16.0844 58.0761 16.4553 58.3313 16.9469L64.8656 29.4579C64.9981 29.7083 65.0792 29.9827 65.1041 30.265C65.129 30.5472 65.0972 30.8316 65.0106 31.1013C64.924 31.3711 64.7843 31.6208 64.5997 31.8358C64.4152 32.0508 64.1895 32.2267 63.9359 32.3532V32.3532Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6245 35.3548L4.06361 32.061C3.81099 31.9372 3.58584 31.7639 3.40156 31.5513C3.21727 31.3387 3.07761 31.0913 2.99088 30.8237C2.90415 30.556 2.87212 30.2737 2.89669 29.9934C2.92127 29.7132 3.00194 29.4407 3.13392 29.1923L9.6683 16.6814C9.92391 16.19 10.3613 15.8179 10.8872 15.6443C11.4131 15.4706 11.986 15.5091 12.4839 15.7517L19.1245 19.072L10.6245 35.3548Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.375 35.6204L53.125 40.6141L43.35 50.3891C43.0836 50.6382 42.7608 50.8191 42.4092 50.9163C42.0576 51.0134 41.6878 51.0239 41.3313 50.9469L25.925 47.0954C25.6436 47.0169 25.3813 46.8813 25.1547 46.6969L10.625 35.3547",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.125 40.614L41.4375 32.114L38.0375 34.664C36.5645 35.7634 34.7756 36.3574 32.9375 36.3574C31.0994 36.3574 29.3105 35.7634 27.8375 34.664L26.4031 33.575C26.1606 33.3906 25.9599 33.1567 25.8145 32.889C25.6691 32.6212 25.5822 32.3256 25.5596 32.0218C25.537 31.7179 25.5792 31.4127 25.6834 31.1264C25.7876 30.8401 25.9514 30.5792 26.1641 30.3609L36.5766 19.975C36.7722 19.7803 37.0042 19.6262 37.2595 19.5214C37.5147 19.4165 37.7881 19.3631 38.0641 19.364H48.875",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2842 19.0718L32.9107 15.0875C33.3949 14.9486 33.9127 14.9863 34.3717 15.1937L43.5623 19.364",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 56.5516L21.7547 54.5328C21.4289 54.4592 21.1272 54.3038 20.8781 54.0813L14.875 48.875",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6e3e80a264b65fc5ab9c705b73028049.svg";
export { ForwardRef as ReactComponent };